import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import type { Variants } from "framer-motion";
import { Link } from "react-router-dom";

import {
  ClipboardDocumentListIcon,
  ChevronUpIcon,
  PencilSquareIcon,
} from "@heroicons/react/24/outline";

const FloatingMenu: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isHover, setIsHover] = useState(false);

  const menuItems = [
    {
      label: "Daftar Konvensi",
      to: "/registration/convention", // ✅ gunakan "to" bukan "href"
      bgColor: "bg-primary dark:bg-blue-600",
    },
    {
      label: "Daftar Konferensi",
      to: "/#conference-tracks",
      bgColor: "bg-primary dark:bg-blue-600",
    },
  ];

  const menuVariants: Variants = {
    hidden: { opacity: 0, y: 20, scale: 0.95 },
    visible: (i: number = 0) => ({
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        delay: i * 0.08,
        type: "spring",
        stiffness: 300,
        damping: 20,
      },
    }),
    exit: { opacity: 0, y: 20, scale: 0.9, transition: { duration: 0.2 } },
  };

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3">
      {/* Menu Items */}
      <AnimatePresence>
        {isOpen &&
          menuItems.map((item, i) => (
            <motion.div
              key={item.label}
              variants={menuVariants}
              initial="hidden"
              animate="visible"
              exit="exit"
              custom={i}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <Link
                to={item.to}
                className={`flex items-center gap-3 pl-4 pr-5 py-3 text-white dark:text-gray-100 font-semibold rounded-full shadow-lg ${item.bgColor} hover:opacity-90 transition`}
                onClick={() => setIsOpen(false)} // ✅ otomatis tutup menu setelah klik
              >
                <PencilSquareIcon className="w-5 h-5" />
                <span className="text-sm">{item.label}</span>
              </Link>
            </motion.div>
          ))}
      </AnimatePresence>

      {/* Floating Button + Tooltip */}
      <div
        className="relative flex items-center"
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
      >
        {/* Tooltip */}
        <AnimatePresence>
          {!isOpen && isHover && (
            <motion.div
              initial={{ opacity: 0, x: 10 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 10 }}
              transition={{ duration: 0.2 }}
              className="absolute right-16 bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-900 text-sm px-3 py-1 rounded-md shadow-md whitespace-nowrap"
            >
              Daftar
            </motion.div>
          )}
        </AnimatePresence>

        <motion.button
          onClick={() => setIsOpen(!isOpen)}
          whileTap={{ scale: 0.9 }}
          className="flex items-center justify-center w-14 h-14 rounded-full bg-yellow-500 dark:bg-yellow-600 text-white dark:text-gray-100 shadow-lg hover:opacity-90 transition-colors duration-300"
        >
          {isOpen ? (
            <ChevronUpIcon className="w-7 h-7" />
          ) : (
            <ClipboardDocumentListIcon className="w-7 h-7" />
          )}
        </motion.button>
      </div>
    </div>
  );
};

export default FloatingMenu;
